var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"loading-panel"},[_c('LoadingAnimation')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }